import React from "react";
  
  
  export default function Resale(props) {
  
  
  return(<div>Resale</div>)
  };